import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type {
  ListQueryParams,
  PermissionGroupListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const permissionGroupKeys = {
  all: () => ['permissionGroups'] as const,
  list: (props: { url: string; queryParams?: ListQueryParams }) =>
    [
      ...permissionGroupKeys.all(),
      'list',
      props.url,
      props.queryParams,
    ] as const,
};

export const permissionGroupQueries = {
  list: (props: { url: string; queryParams?: ListQueryParams }) =>
    queryOptions({
      queryKey: permissionGroupKeys.list(props),
      queryFn: () =>
        HttpClient.request<PermissionGroupListResponseData>({
          method: 'GET',
          url: props.url,
          params: props.queryParams,
        }),
      enabled: !!props.url,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),
};
